var render = function render(){
  var _vm$projectData, _vm$projectData$compa, _vm$projectData2, _vm$projectData3, _vm$projectData4, _vm$projectData5, _vm$projectData6, _vm$projectData6$cont, _vm$projectData7, _vm$projectData7$cont, _vm$projectData8, _vm$projectData8$term, _vm$projectData9, _vm$projectData10, _vm$projectData11, _vm$projectData12, _vm$projectData13, _vm$projectData14, _vm$projectData14$car, _vm$projectData15, _vm$projectData16, _vm$projectData17, _vm$projectData17$pro, _vm$projectData18;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "real-shipment"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "float-right mr-1",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openSlideFormRealShipment('ADD', null, null);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   ADD REAL SHIPMENT ")])], 1)], 1), _vm._m(0), _c('div', {
    staticClass: "info-grid px-3"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Company Name")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData = _vm.projectData) === null || _vm$projectData === void 0 ? void 0 : (_vm$projectData$compa = _vm$projectData.company) === null || _vm$projectData$compa === void 0 ? void 0 : _vm$projectData$compa.company))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Fleet Ownership")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData2 = _vm.projectData) === null || _vm$projectData2 === void 0 ? void 0 : _vm$projectData2.fleet_ownership))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Fleet Type")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value chips"
  }, _vm._l((_vm$projectData3 = _vm.projectData) === null || _vm$projectData3 === void 0 ? void 0 : _vm$projectData3.fleet_type_ids, function (item, index) {
    return _c('span', {
      key: index,
      staticClass: "chip"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.text) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Period")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s((_vm$projectData4 = _vm.projectData) !== null && _vm$projectData4 !== void 0 && _vm$projectData4.period && ((_vm$projectData5 = _vm.projectData) === null || _vm$projectData5 === void 0 ? void 0 : _vm$projectData5.period.length) === 2 ? "".concat(_vm.moment(_vm.projectData.period[0]).format('DD/MM/YYYY'), " - ").concat(_vm.moment(_vm.projectData.period[1]).format('DD/MM/YYYY')) : '-') + " ")])]), _vm._m(1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Contract Type")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_c('div', [_vm._v(_vm._s(((_vm$projectData6 = _vm.projectData) === null || _vm$projectData6 === void 0 ? void 0 : (_vm$projectData6$cont = _vm$projectData6.contract_type) === null || _vm$projectData6$cont === void 0 ? void 0 : _vm$projectData6$cont.name) || '-'))]), (_vm$projectData7 = _vm.projectData) !== null && _vm$projectData7 !== void 0 && (_vm$projectData7$cont = _vm$projectData7.contract_type) !== null && _vm$projectData7$cont !== void 0 && _vm$projectData7$cont.is_spal ? _c('div', {
    staticClass: "badge-info"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" This type using SPAL ")]) : _vm._e()])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Term")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData8 = _vm.projectData) === null || _vm$projectData8 === void 0 ? void 0 : (_vm$projectData8$term = _vm$projectData8.terms) === null || _vm$projectData8$term === void 0 ? void 0 : _vm$projectData8$term.code))])])]), _c('div', {
    staticClass: "right"
  }, [_vm._m(2), _vm._m(3), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Distance")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData9 = _vm.projectData) === null || _vm$projectData9 === void 0 ? void 0 : _vm$projectData9.distance))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Laycan")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s((_vm$projectData10 = _vm.projectData) !== null && _vm$projectData10 !== void 0 && _vm$projectData10.laycan && ((_vm$projectData11 = _vm.projectData) === null || _vm$projectData11 === void 0 ? void 0 : _vm$projectData11.laycan.length) === 2 ? "".concat(_vm.moment((_vm$projectData12 = _vm.projectData) === null || _vm$projectData12 === void 0 ? void 0 : _vm$projectData12.laycan[0]).format('DD/MM/YYYY'), " - ").concat(_vm.moment((_vm$projectData13 = _vm.projectData) === null || _vm$projectData13 === void 0 ? void 0 : _vm$projectData13.laycan[1]).format('DD/MM/YYYY')) : '-') + " ")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Cargo Type")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData14 = _vm.projectData) === null || _vm$projectData14 === void 0 ? void 0 : (_vm$projectData14$car = _vm$projectData14.cargo_type) === null || _vm$projectData14$car === void 0 ? void 0 : _vm$projectData14$car.name))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Total Plan QTY")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData15 = _vm.projectData) === null || _vm$projectData15 === void 0 ? void 0 : _vm$projectData15.total_quantity))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Remarks")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm$projectData16 = _vm.projectData) === null || _vm$projectData16 === void 0 ? void 0 : _vm$projectData16.remarks))])])])])], 1), _c('section', {
    staticClass: "section"
  }, [_vm._m(4), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-custom"
  }, [_vm._m(5), ((_vm$projectData17 = _vm.projectData) === null || _vm$projectData17 === void 0 ? void 0 : (_vm$projectData17$pro = _vm$projectData17.project_contract_plan) === null || _vm$projectData17$pro === void 0 ? void 0 : _vm$projectData17$pro.length) > 0 ? _c('tbody', _vm._l((_vm$projectData18 = _vm.projectData) === null || _vm$projectData18 === void 0 ? void 0 : _vm$projectData18.project_contract_plan, function (val, index) {
    var _val$cargo_type, _val$plan_quantity, _vm$projectData19;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "check"
    }, [_c('b-form-checkbox', {
      model: {
        value: val.checked,
        callback: function callback($$v) {
          _vm.$set(val, "checked", $$v);
        },
        expression: "val.checked"
      }
    })], 1), _c('td', [_c('a', {
      staticClass: "link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : val.shipment_plan_detail_number) + " ")])]), _c('td', _vm._l(val === null || val === void 0 ? void 0 : val.fleets, function (obj, objIndex) {
      return _c('span', {
        key: objIndex,
        staticClass: "badge-fleet mr-1"
      }, [_vm._v(" " + _vm._s(_vm.showVehicleName(obj.vehicle_id)) + " ")]);
    }), 0), _c('td', [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : (_val$cargo_type = val.cargo_type) === null || _val$cargo_type === void 0 ? void 0 : _val$cargo_type.name))]), _c('td', [_vm._v(" " + _vm._s(val === null || val === void 0 ? void 0 : (_val$plan_quantity = val.plan_quantity) === null || _val$plan_quantity === void 0 ? void 0 : _val$plan_quantity.toLocaleString()) + " " + _vm._s((_vm$projectData19 = _vm.projectData) === null || _vm$projectData19 === void 0 ? void 0 : _vm$projectData19.unit) + " ")]), _c('td', {
      staticClass: "text-uppercase"
    }, [_vm._v(_vm._s(val === null || val === void 0 ? void 0 : val.status))]), _c('td', [_c('b-button', {
      staticClass: "btn-desc",
      attrs: {
        "size": "sm",
        "variant": "primary"
      }
    }, [_vm._v(" Description ")])], 1), _c('td', [_c('b-button', {
      staticClass: "btn-remarks",
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      }
    }, [_vm._v(" Remarks ")])], 1)]);
  }), 0) : _c('tbody', [_vm._m(6)])]), _c('b-sidebar', {
    attrs: {
      "id": "slideFormRealShipment",
      "title": "Create Real Shipment",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _vm$projectData20;
        var hide = _ref.hide;
        return [_c('SlideFormRealShipment', {
          attrs: {
            "closeSlideFormRealShipment": _vm.closeSlideFormRealShipment,
            "refreshData": _vm.fetchRealShipment,
            "optionsFleets": _vm.optionsFleets,
            "projectId": (_vm$projectData20 = _vm.projectData) === null || _vm$projectData20 === void 0 ? void 0 : _vm$projectData20.id,
            "action": _vm.action,
            "detailRealShipment": _vm.detailRealShipment,
            "showVehicleName": _vm.showVehicleName
          }
        })];
      }
    }]),
    model: {
      value: _vm.slideFormRealShipment,
      callback: function callback($$v) {
        _vm.slideFormRealShipment = $$v;
      },
      expression: "slideFormRealShipment"
    }
  })], 1)]), _c('section', {
    staticClass: "section"
  }, [_vm._m(7), _c('div', {
    staticClass: "table-wrap",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-custom"
  }, [_vm._m(8), _vm.listRealShipment && _vm.listRealShipment.length > 0 ? _c('tbody', _vm._l(_vm.listRealShipment, function (state, index) {
    var _state$project_plan, _state$dataTrip, _state$dataTrip$tripR, _state$dataTrip2, _state$dataTrip2$trip, _state$project_plan2, _state$project_plan2$, _state$dataTrip3, _state$dataTrip4, _state$dataTrip4$trip, _state$dataTrip5, _state$dataTrip5$trip, _state$dataTrip5$trip2, _state$dataTrip6, _state$dataTrip6$trip, _state$dataTrip6$trip2, _state$dataTrip7, _state$dataTrip7$trip, _state$dataTrip7$trip2, _state$dataTrip8, _state$dataTrip8$trip, _state$dataTrip9, _state$dataTrip9$trip, _state$dataTrip10, _state$dataTrip10$tri, _state$dataTrip11, _state$dataTrip11$tri, _state$dataTrip12, _state$dataTrip12$tri, _state$dataTrip12$tri2, _state$dataTrip13, _state$dataTrip13$tri, _state$dataTrip14, _state$dataTrip14$tri, _state$dataTrip15, _state$dataTrip15$tri, _state$dataTrip16, _state$dataTrip16$tri, _state$price, _state$price_to_vendo;
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.status))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$project_plan = state.project_plan) === null || _state$project_plan === void 0 ? void 0 : _state$project_plan.shipment_plan_detail_number))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip = state.dataTrip) === null || _state$dataTrip === void 0 ? void 0 : (_state$dataTrip$tripR = _state$dataTrip.tripRecord) === null || _state$dataTrip$tripR === void 0 ? void 0 : _state$dataTrip$tripR.startDate))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip2 = state.dataTrip) === null || _state$dataTrip2 === void 0 ? void 0 : (_state$dataTrip2$trip = _state$dataTrip2.tripRecord) === null || _state$dataTrip2$trip === void 0 ? void 0 : _state$dataTrip2$trip.endDate))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$project_plan2 = state.project_plan) === null || _state$project_plan2 === void 0 ? void 0 : (_state$project_plan2$ = _state$project_plan2.plan_quantity) === null || _state$project_plan2$ === void 0 ? void 0 : _state$project_plan2$.toLocaleString()))]), _c('td', _vm._l(state === null || state === void 0 ? void 0 : (_state$dataTrip3 = state.dataTrip) === null || _state$dataTrip3 === void 0 ? void 0 : _state$dataTrip3.vehicle, function (obj, objIndex) {
      return _c('span', {
        key: objIndex,
        staticClass: "badge-fleet mr-1"
      }, [_vm._v(" " + _vm._s(obj === null || obj === void 0 ? void 0 : obj.name) + " ")]);
    }), 0), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip4 = state.dataTrip) === null || _state$dataTrip4 === void 0 ? void 0 : (_state$dataTrip4$trip = _state$dataTrip4.tripRecord) === null || _state$dataTrip4$trip === void 0 ? void 0 : _state$dataTrip4$trip.cargoType))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip5 = state.dataTrip) === null || _state$dataTrip5 === void 0 ? void 0 : (_state$dataTrip5$trip = _state$dataTrip5.tripRecord) === null || _state$dataTrip5$trip === void 0 ? void 0 : (_state$dataTrip5$trip2 = _state$dataTrip5$trip.cargoLoading) === null || _state$dataTrip5$trip2 === void 0 ? void 0 : _state$dataTrip5$trip2.toLocaleString()))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip6 = state.dataTrip) === null || _state$dataTrip6 === void 0 ? void 0 : (_state$dataTrip6$trip = _state$dataTrip6.tripRecord) === null || _state$dataTrip6$trip === void 0 ? void 0 : (_state$dataTrip6$trip2 = _state$dataTrip6$trip.cargoUnloading) === null || _state$dataTrip6$trip2 === void 0 ? void 0 : _state$dataTrip6$trip2.toLocaleString()))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip7 = state.dataTrip) === null || _state$dataTrip7 === void 0 ? void 0 : (_state$dataTrip7$trip = _state$dataTrip7.tripRecord) === null || _state$dataTrip7$trip === void 0 ? void 0 : (_state$dataTrip7$trip2 = _state$dataTrip7$trip.portLoading) === null || _state$dataTrip7$trip2 === void 0 ? void 0 : _state$dataTrip7$trip2.portName))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip8 = state.dataTrip) === null || _state$dataTrip8 === void 0 ? void 0 : (_state$dataTrip8$trip = _state$dataTrip8.tripRecord) === null || _state$dataTrip8$trip === void 0 ? void 0 : _state$dataTrip8$trip.polArrivalTime))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip9 = state.dataTrip) === null || _state$dataTrip9 === void 0 ? void 0 : (_state$dataTrip9$trip = _state$dataTrip9.tripRecord) === null || _state$dataTrip9$trip === void 0 ? void 0 : _state$dataTrip9$trip.polBerthing))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip10 = state.dataTrip) === null || _state$dataTrip10 === void 0 ? void 0 : (_state$dataTrip10$tri = _state$dataTrip10.tripRecord) === null || _state$dataTrip10$tri === void 0 ? void 0 : _state$dataTrip10$tri.polCommenced))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip11 = state.dataTrip) === null || _state$dataTrip11 === void 0 ? void 0 : (_state$dataTrip11$tri = _state$dataTrip11.tripRecord) === null || _state$dataTrip11$tri === void 0 ? void 0 : _state$dataTrip11$tri.polCompleted))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip12 = state.dataTrip) === null || _state$dataTrip12 === void 0 ? void 0 : (_state$dataTrip12$tri = _state$dataTrip12.tripRecord) === null || _state$dataTrip12$tri === void 0 ? void 0 : (_state$dataTrip12$tri2 = _state$dataTrip12$tri.portDischarge) === null || _state$dataTrip12$tri2 === void 0 ? void 0 : _state$dataTrip12$tri2.portName))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip13 = state.dataTrip) === null || _state$dataTrip13 === void 0 ? void 0 : (_state$dataTrip13$tri = _state$dataTrip13.tripRecord) === null || _state$dataTrip13$tri === void 0 ? void 0 : _state$dataTrip13$tri.podArrivalTime))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip14 = state.dataTrip) === null || _state$dataTrip14 === void 0 ? void 0 : (_state$dataTrip14$tri = _state$dataTrip14.tripRecord) === null || _state$dataTrip14$tri === void 0 ? void 0 : _state$dataTrip14$tri.podBerthing))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip15 = state.dataTrip) === null || _state$dataTrip15 === void 0 ? void 0 : (_state$dataTrip15$tri = _state$dataTrip15.tripRecord) === null || _state$dataTrip15$tri === void 0 ? void 0 : _state$dataTrip15$tri.podCommenced))]), _c('td', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$dataTrip16 = state.dataTrip) === null || _state$dataTrip16 === void 0 ? void 0 : (_state$dataTrip16$tri = _state$dataTrip16.tripRecord) === null || _state$dataTrip16$tri === void 0 ? void 0 : _state$dataTrip16$tri.podCompleted))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$price = state.price) === null || _state$price === void 0 ? void 0 : _state$price.toLocaleString()))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$price_to_vendo = state.price_to_vendor) === null || _state$price_to_vendo === void 0 ? void 0 : _state$price_to_vendo.toLocaleString()))]), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-primary"
      },
      on: {
        "click": function click($event) {
          return _vm.openSlideFormRealShipment('DETAIL', state === null || state === void 0 ? void 0 : state.id, state);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye mr-1"
    }), _vm._v(" Detail ")])], 1)]);
  }), 0) : _c('tbody', [_vm._m(9)])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("PROJECT INFO")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Shipment Plan Number")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("ownship-sfc-2509-0003")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Port of Loading")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bengalon")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Port of Discharging")]), _c('div', {
    staticClass: "colon"
  }, [_vm._v(":")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Paiton")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("DETAIL SHIPMENT PLAN")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "check"
  }), _c('th', [_vm._v("Number Detail Plan")]), _c('th', [_vm._v("Fleet")]), _c('th', [_vm._v("Cargo Type")]), _c('th', [_vm._v("Plan QTY")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Description")]), _c('th', [_vm._v("Remarks")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" No detail shipment plan. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("FLEET OPERATIONS")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Detail Plan")]), _c('th', [_vm._v("ETA POL")]), _c('th', [_vm._v("ETA POD")]), _c('th', [_vm._v("Plan QTY")]), _c('th', [_vm._v("Fleet")]), _c('th', [_vm._v("Cargo Type")]), _c('th', [_vm._v("Cargo Loading")]), _c('th', [_vm._v("Cargo Unloading")]), _c('th', [_vm._v("POL")]), _c('th', [_vm._v("TA POL")]), _c('th', [_vm._v("Berthing")]), _c('th', [_vm._v("Commenced")]), _c('th', [_vm._v("Completed")]), _c('th', [_vm._v("POD")]), _c('th', [_vm._v("TA POD")]), _c('th', [_vm._v("Berthing")]), _c('th', [_vm._v("Commenced")]), _c('th', [_vm._v("Completed")]), _c('th', [_vm._v("Price")]), _c('th', [_vm._v("Price To Vendor")]), _c('th', [_vm._v("Action")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "23"
    }
  }, [_vm._v(" No Data Real Shipment. ")])]);

}]

export { render, staticRenderFns }